import React from 'react'
import { useSelector } from 'react-redux'
import cn from 'classnames'
import Link from 'redux-first-router-link'
import { text } from '@groovehq/internal-design-system/lib/styles/elements'
import { selectAccountPreferenceHideReporting } from 'selectors/app/selectAccountPreferences'
import { selectCurrentUserIsOwner } from 'ducks/currentUser'
import { SETTINGS_INTEGRATIONS_PAGE } from 'subapps/settings/types'
import { selectCurrentPage } from 'selectors/location'
import { selectSettingsLandingPageAction } from 'selectors/menus'
import { LANDING_PAGE as KB_LANDING_PAGE } from 'subapps/kb/pages'
import CentralizeSection from './CentralizeSection'
import AnalyzeSection from './AnalyzeSection'
import IntegrationsSection from './IntegrationsSection'
import { styles } from './styles'

const Nav = ({ className, active }) => {
  const hideReporting = useSelector(selectAccountPreferenceHideReporting)
  const currentUserIsOwner = useSelector(selectCurrentUserIsOwner)
  const showReporting = currentUserIsOwner || !hideReporting
  const settingsLandingPageAction = useSelector(selectSettingsLandingPageAction)

  const settingsActive =
    useSelector(selectCurrentPage) !== SETTINGS_INTEGRATIONS_PAGE &&
    active === 'Settings'

  return (
    <nav className={className}>
      <div
        css={[text.styles.fontMedium, styles.list]}
        className="grui flex items-center"
      >
        <CentralizeSection css={styles.item} active={active} />
        {showReporting && <AnalyzeSection css={styles.item} active={active} />}

        <Link
          to={{ type: KB_LANDING_PAGE }}
          css={styles.item}
          className={cn('grui mx-12', active === 'Knowledge Base' && 'active')}
        >
          Knowledge Base
        </Link>

        <IntegrationsSection css={styles.item} />

        <Link
          to={settingsLandingPageAction}
          css={styles.item}
          className={cn('grui mx-12', settingsActive && 'active')}
        >
          Settings
        </Link>
      </div>
    </nav>
  )
}

export default Nav
